import React from 'react';
import { PageSection, BodyText, Title } from 'common/styles/page';
import styled from 'styled-components';

import { useApiPortalV1AssessmentsResultsListQuery } from 'areas/assessment-schedule/api';
import { useSelector } from 'react-redux';
import { BulletListFormatter } from 'common/utils/AIUtils';
import { getMemberId, getMostRecentAssessmentPeriodId } from 'common/selectors/auth';

import { AggregateType } from 'common/constants/AggregateType';
const ClampedBody = styled(BodyText)`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: calc(20px * 5);
  transition: max-height 0.12s ease;
  cursor: help;

  &:hover {
    display: block;
    -webkit-line-clamp: unset;
    max-height: none;
    overflow: visible;
    white-space: pre-wrap;
  }
`;

interface TeamInsightsProps {
  team_id: number;
}

const TeamInsights: React.FC<TeamInsightsProps> = ({ team_id }) => {
  const assessmentPeriodId = useSelector(getMostRecentAssessmentPeriodId);
  const currentUserId = useSelector(getMemberId);

  const { data: ai_sentiment_data } = useApiPortalV1AssessmentsResultsListQuery({
    aggregateType: AggregateType.TEAM_SUMMARY,
    assessmentPeriodId: assessmentPeriodId,
    employeeId: currentUserId ?? undefined,
  });

  if (!ai_sentiment_data) return <div>Loading...</div>;

  // Backend returns { summaries: [{ summary, team_id, team_name }, ...] }
  const result = ai_sentiment_data?.[0]?.result;
  const summaries = (result as any)?.summaries;
  const ai_sentiment = Array.isArray(summaries) ? summaries.find((s: any) => Number(s.team_id) === team_id) : undefined;

  const team_name = ai_sentiment?.team_name ?? 'Team';
  const summary = ai_sentiment?.summary ?? 'No summary available for this team.';

  return (
    <PageSection>
      <Title padbottom="10px">{team_name} Insights</Title>

      {ai_sentiment_data && (
        <>
          <ClampedBody title={summary} aria-label={summary}>{summary}</ClampedBody>
          <BodyText>{BulletListFormatter(ai_sentiment?.bullets)}</BodyText>
        </>
      )}
    </PageSection>
  );
};
export default TeamInsights;


